import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getRegionConfig } from '../config/regionConfig';

import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import zh from './locales/zh.json';
import ur from './locales/ur.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  zh: { translation: zh },
  ur: { translation: ur }
};

const config = getRegionConfig();
const defaultLng = config.defaultLanguage || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLng,
    debug: false,
    
    interpolation: {
      escapeValue: false
    },

    detection: {
      // Prioritize localStorage. If nothing is saved, fall back to region default, bypassing navigator if region specifies a default.
      order: ['localStorage', config.defaultLanguage ? 'path' : 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
